// extracted by mini-css-extract-plugin
export default {"tabHeader":"taxpayment-tabs_tabHeader__T1FYy","tabSelected":"taxpayment-tabs_tabSelected__dM114"};